/* eslint-disable class-methods-use-this */
import * as _ from 'lodash';

/**
 * Field validator plugin
 */
export class FieldValidatorPlugin {
  static required(config) {
    return {
      validate: (field) => !(_.isEmpty(field.value)),
      error: { slug: 'required', config },
    };
  }

  static noWhitespace(config) {
    const regEx = new RegExp('^\\s$');

    return {
      validate: (field) => !(regEx.test((field.value || '').toString()[0])),
      error: { slug: 'whitespace', config },
    };
  }

  static len(config) {
    if (!config.min && !config.max) return null;

    const minLength = config.min && config.min > 0 ? config.min : null;
    const maxLength = config.max && config.max > 0 ? config.max : null;

    const regEx = new RegExp(`^.{${minLength || '0'},${maxLength || ''}}$`);

    return {
      validate: (field) => regEx.test(field.value),
      error: { slug: 'length', config },
    };
  }

  static repeating(config) {
    let pattern;
    if (config.numbers) {
      pattern = `([0-9])${_.repeat('\\1', config.max)}`;
    } else if (config.alpha) {
      pattern = `([a-z])${_.repeat('\\1', config.max)}`;
    }

    const regEx = new RegExp(pattern);

    return {
      validate: (field) => !regEx.test(field.value),
      error: { slug: 'repeating', config },
    };
  }

  static specialCharacters(config) {
    if (!config.min) return null;

    const regEx = new RegExp(`(?:[^\`!@#$%^&*\\-_=+'/.,]*[\`!@#$%^&*\\-_=+'/.,]){${config.min}}`);

    return {
      validate: (field) => regEx.test(field.value),
      error: { slug: 'special-characters', config },
    };
  }

  static numericCharacters(config) {
    if (!config.min) return null;

    const regEx = new RegExp(`(?:.*[0-9]){${config.min}}`);

    return {
      validate: (field) => regEx.test(field.value),
      error: { slug: 'numeric-characters', config },
    };
  }

  static caseLetters(config) {
    if (!config.case && !config.min) return null;

    let pattern;
    if (config.case === 'upper') {
      pattern = `(?:.*[A-Z]){${config.min}}`;
    } else if (config.case === 'lower') {
      pattern = `(?:.*[a-z]){${config.min}}`;
    }

    const regEx = new RegExp(pattern);

    return {
      validate: (field) => regEx.test(field.value),
      error: { slug: `${config.case}-case`, config },
    };
  }

  static pattern(config) {
    if (!config.pattern) return null;

    const regEx = new RegExp(config.pattern);

    return {
      validate: (field) => regEx.test(field.value),
      error: { slug: 'pattern', config },
    };
  }
}
